import * as requestFromServer from "./LeadgerSummaryReportCrud";
import { AddContestSlice1, callTypes } from "./LeadgerSummaryReportSlice";
import { NotificationManager } from "react-notifications";

const { actions } = AddContestSlice1;
export const fetchCompanyList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.fetchCompanyList(queryParams)
    .then(response => {
      console.log("response::All Company List", response?.list)
      // const { totalCount, entities } = response.data;
      const companyList = response?.list;
      console.log("fetchCompanyList", companyList)
      dispatch(actions.CompanyList({ companyList }));
      return response
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message;
      NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

